export const REQUEST_FETCH_OBJECTIVES = "request_fetch_objectives"
export const FETCH_OBJECTIVES_SUCCESS = "fetch_objective_success"
export const FETCH_OBJECTIVES_FAILURE = "fetch_objectives_failure"
export const OBJECTIVE_ACTION_CHANGES = "objective_action_changes"

export const CLEAR_FETCH_OBJECTIVES = "clear_fetch_objectives"